import React, { useEffect, useRef, useContext } from "react";
// import { useImmer } from "use-immer"
import { Link, useNavigate } from "react-router-dom";
import StateContext from "../StateContext";
import DispatchContext from "../DispatchContext";

import LockButton from "./LockButton";

function ChapitreListItem(props) {
  const appState = useContext(StateContext);
  const appDispatch = useContext(DispatchContext);

  let navigate = useNavigate();

  function handleChapterClick() {
    appDispatch({ type: "CLEAR_ALL_CANVAS", value: true });
    navigate(`/chapitre/${props.id}`, { replace: false });
  }

  const sectionRef = useRef(null);
  const itemRef = useRef(null);

  const locked = appState.status[props.index].locked;

  useEffect(() => {
    if (props.index === 0) {
      // Chapter 1
      appDispatch({
        type: "UPDATE_CHAPTER_PATHS",
        chapterIndex: props.index,
        value: [
          {
            color: "#A6CE39",
            startX: window.innerWidth / 2,
            startY:
              sectionRef.current.getBoundingClientRect().top +
              window.pageYOffset +
              10,
            step1X: window.innerWidth / 2,
            step1Y: itemRef.current.offsetTop - 80,
            step2X:
              itemRef.current.offsetLeft + itemRef.current.clientWidth / 2,
            step2Y: itemRef.current.offsetTop - 80,
            stopX: itemRef.current.offsetLeft + itemRef.current.clientWidth / 2,
            stopY: itemRef.current.offsetTop - 10,
          },
          {
            color: appState.status[props.index].locked ? "#B4B4B4" : "#A6CE39",
            startX:
              itemRef.current.offsetLeft + itemRef.current.clientWidth / 2,
            startY:
              itemRef.current.offsetTop + itemRef.current.clientHeight + 15,
            step1X:
              itemRef.current.offsetLeft + itemRef.current.clientWidth / 2,
            step1Y:
              sectionRef.current.getBoundingClientRect().bottom +
              window.pageYOffset,
            step2X:
              window.innerWidth -
              itemRef.current.offsetLeft -
              itemRef.current.clientWidth / 2,
            step2Y:
              sectionRef.current.getBoundingClientRect().bottom +
              window.pageYOffset,
            stopX:
              window.innerWidth -
              itemRef.current.offsetLeft -
              itemRef.current.clientWidth / 2,
            stopY:
              sectionRef.current.clientHeight +
              (itemRef.current.offsetTop - 10), // = difference between normal padding-top and first section padding top,
          },
        ],
      });
    } else if (props.index === props.chapitresLength - 1) {
      // Last chapter
      appDispatch({
        type: "UPDATE_CHAPTER_PATHS",
        chapterIndex: props.index,
        value: [
          {
            color: appState.status[props.index].locked ? "#B4B4B4" : "#A6CE39",
            startX:
              itemRef.current.offsetLeft + itemRef.current.clientWidth / 2,
            startY:
              itemRef.current.offsetTop + itemRef.current.clientHeight + 15,
            step1X:
              itemRef.current.offsetLeft + itemRef.current.clientWidth / 2,
            step1Y:
              sectionRef.current.getBoundingClientRect().bottom +
              window.pageYOffset -
              80,
            step2X: window.innerWidth / 2,
            step2Y:
              sectionRef.current.getBoundingClientRect().bottom +
              window.pageYOffset -
              80,
            stopX: window.innerWidth / 2,
            stopY:
              sectionRef.current.getBoundingClientRect().bottom +
              window.pageYOffset -
              10,
          },
        ],
      });
    } else if (props.index % 2 === 0) {
      // Odd # chapters
      appDispatch({
        type: "UPDATE_CHAPTER_PATHS",
        chapterIndex: props.index,
        value: [
          {
            color: appState.status[props.index].locked ? "#B4B4B4" : "#A6CE39",
            startX:
              itemRef.current.offsetLeft + itemRef.current.clientWidth / 2,
            startY:
              itemRef.current.offsetTop + itemRef.current.clientHeight + 15,
            step1X:
              itemRef.current.offsetLeft + itemRef.current.clientWidth / 2,
            step1Y:
              sectionRef.current.getBoundingClientRect().bottom +
              window.pageYOffset,
            step2X:
              window.innerWidth -
              itemRef.current.offsetLeft -
              itemRef.current.clientWidth / 2,
            step2Y:
              sectionRef.current.getBoundingClientRect().bottom +
              window.pageYOffset,
            stopX:
              window.innerWidth -
              itemRef.current.offsetLeft -
              itemRef.current.clientWidth / 2,
            stopY:
              sectionRef.current.clientHeight + itemRef.current.offsetTop - 10,
          },
        ],
      });
    } else {
      // Even # chapters
      appDispatch({
        type: "UPDATE_CHAPTER_PATHS",
        chapterIndex: props.index,
        value: [
          {
            color: appState.status[props.index].locked ? "#B4B4B4" : "#A6CE39",
            startX:
              itemRef.current.offsetLeft + itemRef.current.clientWidth / 2,
            startY:
              itemRef.current.offsetTop + itemRef.current.clientHeight + 15,
            step1X:
              itemRef.current.offsetLeft + itemRef.current.clientWidth / 2,
            step1Y:
              sectionRef.current.getBoundingClientRect().bottom +
              window.pageYOffset,
            step2X:
              window.innerWidth -
              itemRef.current.offsetLeft -
              itemRef.current.clientWidth / 2,
            step2Y:
              sectionRef.current.getBoundingClientRect().bottom +
              window.pageYOffset,
            stopX:
              window.innerWidth -
              itemRef.current.offsetLeft -
              itemRef.current.clientWidth / 2,
            stopY:
              sectionRef.current.clientHeight + itemRef.current.offsetTop - 10,
          },
        ],
      });
    }
  }, [appState.resizeCounter, appState.lockCounter]);

  return (
    <section ref={sectionRef} className="section-chapitre">
      <div
        id={`chapitre-${props.id}`}
        className={`box section-chapitre__chapitre ${
          locked ? "locked" : "unlocked"
        }`}
        ref={itemRef}
      >
        <button
          // to={`/chapitre/${props.id}`}
          className="section-chapitre__chapitre--link"
          onClick={handleChapterClick}
        >
          <h2>
            <span
              className={`section-chapitre__chapitre--maintitle ${
                locked ? "locked" : "unlocked"
              }`}
              dangerouslySetInnerHTML={{ __html: props.titre }}
            ></span>
            <span
              className={`section-chapitre__chapitre--subtitle ${
                locked ? "locked" : "unlocked"
              }`}
              dangerouslySetInnerHTML={{ __html: props.sousTitre }}
            ></span>
          </h2>
        </button>
        <LockButton parentIdx={props.index} readOnly={false} />
      </div>
      <div className={`section-chapitre__mascotte`}>
        <img src={`images/${props.isbn}/mascotte-${props.id}.png`} alt="" />
      </div>
    </section>
  );
}

export default ChapitreListItem;
